// extracted by mini-css-extract-plugin
export default {"h1":"style_h1__ip4ti","h2":"style_h2__YtJGV","h":"style_h__Km8g9"};